import { AlertTriangle, UserX } from "lucide-react";

/** Unresolved people and server warnings for one draft item. */
export function DraftIssues({ unresolved, warnings }: { unresolved: string[]; warnings: string[] }) {
	if (!unresolved.length && !warnings.length) return null;
	return (
		<div className="space-y-1 text-xs">
			{unresolved.length > 0 && (
				<p className="flex items-start gap-1.5 text-muted-foreground">
					<UserX className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden />
					<span>Not in TaskHub: {unresolved.join(", ")}</span>
				</p>
			)}
			{warnings.map((w) => (
				<p key={w} className="flex items-start gap-1.5 text-warning">
					<AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden />
					<span>{w}</span>
				</p>
			))}
		</div>
	);
}
